import { STATES } from '@/constants/states'
import { map } from '@/utils/lodash'

export const statesShort = () => {
  return map(STATES, (state) => state.shortname)
}
